export const mobileTokens = {
  section: {
    y: {
      xs: 24,
      sm: 28,
      md: 36,
      lg: 56,
    },
    titleGap: {
      xs: 20,
      sm: 24,
      md: 32,
      lg: 40,
    },
  },
  control: {
    height: {
      compact: 40,
      panel: 44,
      dialog: 46,
      field: 48,
      xs: 50,
      sm: 56,
      prominent: 60,
      md: 61,
    },
  },
  hero: {
    titleSize: {
      xs: 40,
      sm: 52,
      md: 56,
    },
    // The home hero lead ("We make luxury car leasing easy. With contract hire,
    // lease a premium brand car for less than you might expect.") wraps to three
    // lines at 375px. A clamp of 2 cut it mid-word; 3 keeps the guard against
    // over-long CMS copy without truncating the standard lead.
    leadClamp: 3,
    leadMarginBottom: {
      xs: 16,
      sm: 22,
      md: 28,
    },
  },
  card: {
    padding: {
      xs: 12,
      sm: 16,
      md: 20,
    },
    gap: {
      xs: 8,
      sm: 10,
      md: 12,
    },
  },
};
